import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Formik, Field, Form } from 'formik';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { LinearProgress } from '@material-ui/core';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { theme } from 'theme/theme';
import { setToken, loadUserAsync } from 'store/slices/userInfoSlice';
import FormikInput from 'components/atoms/FormikInput/FormikInput';
import { login } from '../../api/login';
import Logo from '../../components/atoms/Logo/Logo';
import PasswordInput from '../../components/atoms/PasswordInput/PasswordInput';
import { setJwtToken } from '../../utils/jwt';
import RoleSelect from '../../components/organisms/RoleSelect/RoleSelect';

const Login = () => {
    const classes = useStyles();
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    const dispatch = useDispatch();

    return (
        <Container component="main" maxWidth="xs" className={classes.main}>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="80%"
                position="relative"
            >
                <Logo color={theme.palette.primary.main} />
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Войти в систему
                    </Typography>
                    <Formik
                        initialValues={{
                            username: '',
                            password: '',
                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string().required('Введите логин'),
                            password: Yup.string().required('Введите пароль'),
                        })}
                        onSubmit={(values, { setSubmitting }) => {
                            setSubmitting(true);
                            setJwtToken('');
                            localStorage.removeItem('permissions');

                            login({
                                username: values.username,
                                password: values.password,
                            })
                                .then(({ data }) => {
                                    dispatch(setToken(data.token));
                                    (async function () {
                                        await dispatch(
                                            loadUserAsync(() => {
                                                history.push('/cabinet');
                                            })
                                        );
                                        setSubmitting(false);
                                    })();
                                })
                                .catch(() => {
                                    enqueueSnackbar('Ошибка при входе', { variant: 'error' });
                                    setSubmitting(false);
                                });
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form className={classes.form}>
                                <Field
                                    component={FormikInput}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="username"
                                    label="Логин"
                                    name="username"
                                    autoFocus
                                />
                                <Field
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    name="password"
                                    label="Пароль"
                                    type="password"
                                    id="password"
                                    component={PasswordInput}
                                    autoComplete="current-password"
                                />
                                <FormControlLabel
                                    control={<Checkbox value="remember" color="primary" />}
                                    label="Запомнить"
                                />

                                {isSubmitting && <LinearProgress />}
                                {/*<LinearProgress/>*/}
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    disabled={isSubmitting}
                                    className={classes.submit}
                                >
                                    Войти
                                </Button>
                                <Grid container>
                                    <Grid item xs>
                                        <Link href="#" variant="body2">
                                            Забыли пароль?
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Box>
            <RoleSelect isLogin={true} />
        </Container>
    );
};

const useStyles = makeStyles((theme) => ({
    main: {
        height: '100%',
    },
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(2, 0, 2),
    },
}));

export default Login;
